import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const deleteFilter = async (id) => {
  await request.delete(`/Filter`, { id }, 'Не удалось удалить фильтр');
};

const useDeleteFilterMutation = (options) =>
  useMutation(({ filterId }) => deleteFilter(filterId), options);

export default useDeleteFilterMutation;
